import React from 'react';
import compact from 'lodash/compact';
import { Link } from 'react-router-dom';

import { accountExpertSections, accountGeneralSections } from './common';
import { buildExpertAccountSectionPath, buildUserAccountSectionPath } from './route-paths';

const AT_LEAST_ONE_TIME_SLOT = 'must_have_at_least_one_time_slot';
const STRIPE_PAYMENT_ERROR_CARD = 'stripe_payment_card_error';
const INVALID_STRIPE_PAYMENT = 'invalid_stripe_payment';

const handlePaymentError = {
  message: (options = {}) => {
    const { siteSlug = '', message } = options;
    const urlToPaymentSetting = buildUserAccountSectionPath(accountGeneralSections.PAYMENT_METHODS.href, siteSlug);

    return compact([
      message,
      ' Please click ',
      <Link key='here' to={urlToPaymentSetting}>
        here
      </Link>,
      ' to update your payment card.',
    ]);
  },
};

const SERVER_ERRORS = {
  [AT_LEAST_ONE_TIME_SLOT]: {
    message: (options = {}) => {
      const { siteSlug = '' } = options;

      const urlToAvailability = buildExpertAccountSectionPath(accountExpertSections.AVAILABILITY.href, siteSlug);

      return [
        'There should be at least time slot for scheduled availability. Please click ',
        <Link key='here' to={urlToAvailability}>
          here
        </Link>,
        ' to update your availability.',
      ];
    },
  },
  [STRIPE_PAYMENT_ERROR_CARD]: handlePaymentError,
  [INVALID_STRIPE_PAYMENT]: handlePaymentError,
};

export default SERVER_ERRORS;
